import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-archive-icon',
  templateUrl: './communication-archive.component.html'
})
export class CommunicationArchiveComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
